import './ReportCP.scss';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "../../../helpers/withRouter";
import T from "../../../shared/component/t/T";
import Storage from "../../../helpers/Storage"
import debounce from "lodash.debounce";
import _cloneDeep from "lodash/cloneDeep";
import snippets from "../../../helpers/snippets";
import LastModified from "./LastModified";
import eventBus from '../../../core/utils/EventBus';
import BaseApi from "../../../core/api/BaseApi";
import ReportCP_Buttons from "./ReportCP_Buttons";
import ReportCP_PatientInfo from "./ReportCP_PatientInfo";
import ReportCP_ReportOwners from "./ReportCP_ReportOwners";
import ReportCP_EditorViewer from "./ReportCP_EditorViewer";
import ReportCP_ChooseReports from "./ReportCP_ChooseReports";

const baseApi = new BaseApi();

class ReportCP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            direction: this.props.direction,
            data: this.props.data,
            study: {},
            patientInfo: {},
            canCreateReport: false,
            canCreateAudio: {dictaphone: false, dictaphone_disable_reason: ""},
            canAi: {ai_permission: false, ai_disable_reason: ""},

            uploaded: false,

            mouseTooltip: false,
            anchorEl: null,

            reportModals: [],
            selectedReportModals: "-1",

            expressions: [],

            NewStudyReport: null,
            editorKey: 0,

            images: [],
            imageModals: [],
        }
        this.handleReportLocalization = debounce(this.handleReportLocalization.bind(this), 1000);
    }

    UNSAFE_componentWillMount() {
        this.initLastReport(this.props.data.reportID, true)
        this.initImages(this.props.data.study.series,  this.props.data.patient.id)
    }

    componentDidMount() {
        eventBus.on("refreshExpressions", () => this.initExpressions());
        window.addEventListener("beforeunload", this.handleBeforeUnload, {capture: true})
        window.addEventListener("unload", this.handleBeforeUnload)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //this updates happens when user changed reports, so buttons should change
        if (prevProps.data !== this.props.data){
            this.setState({data: this.props.data}, ()=>{
                this.initLastReport(this.props.data.reportID)
            })
        }
        if (prevProps.language !== this.props.language) {
            this.setState({language: this.props.language})
        }
        if (prevProps.direction !== this.props.direction) {
            this.setState({direction: this.props.direction})
        }
    }

    componentWillUnmount() {
        eventBus.remove("refreshExpressions", () => {});
        eventBus.remove("refreshTemplates", () => {});
        window.removeEventListener("beforeunload", this.handleBeforeUnload, {capture: true});
        window.removeEventListener("unload", this.handleBeforeUnload);
    }

    handleBeforeUnload = (event) => {
        let status = this.state.uploaded ? false : this.doesChanged(this.state.selectedReportModals)
        if (status){
            event.preventDefault();
            return (event.returnValue = "")
        }
    }

    doesChanged = (id) =>{
        let last = {...this.props.data.study.reports[id]}
        let current = {...this.state.NewStudyReport}
        return !snippets.areObjectsEqual(last, current)
    }

    initLastReport = (id, reload = false) => {
		let history = Storage.getNewStudyReportLatest(this.props.data.study.id, id)
		history = this.whichReportersToSend(history, this.props.data.study.reports[id])
		let someProperty = _cloneDeep(this.props.data)
		
	    let history_version = history?.last_history_id
		let server_version = this.props.data.study.reports[id]?.last_history_id
		if (server_version <= history_version) {
			console.log(`preferred local report, local version: ${history_version}, server version: ${server_version}`, )
			// shallow copy (like the one created by Object.assign() or the spread operator ...)
			// only copies the outermost layer and keeps the references to the inner layers
			someProperty.study.reports[id] = {
				...someProperty.study.reports[id],
				findings: history['findings'],
				impression: history['impression'],
				description_name: history['description_name']
			}
		}
		someProperty.reportID = id
		this.initData(someProperty, reload)
	}

    whichReportersToSend = (history, source) => {
        return snippets.areObjectsEqual(source, history) ? source : history
    }

    initData = (data, reload) =>{
        this.setState({
            study: data.study,
            patientInfo: data.patient,
            canCreateReport: data.permissions.new_report,
            canCreateAudio: {dictaphone: data.permissions.dictaphone,
                dictaphone_disable_reason: data.permissions.dictaphone_disable_reason},
	        canAi: {ai_permission: data.permissions.ai},
            NewStudyReport: data.study.reports[data.reportID],
            selectedReportModals: data.reportID
        }, () => {
            this.initModalities()
            this.reloadEditor()
            reload && this.initExpressions()
        })
    }

    initImages(v, patientID) {
        let id = this.props.params.studyID
        let imageSeries = []
        Object.keys(v).map(keys => {
            for (let i = 0; i < v[keys].file_count; i += 1) {
                let obj = {
                    patientID: `${patientID}`,
                    studyID: id,
                    reportID: this.props.params.reportID,
                    imgSeries: keys,
                    imgSeriesFileID: `${v[keys].files[i].id}`,
                    imgSeriesFileLink: `/image/${id}/${keys}/${v[keys].files[i].id}`
                }
                imageSeries = [...imageSeries, obj]
            }
        });
        this.setState({images: imageSeries}, () => { });
    }

    initModalities() {
        let chooseOne = { id: -1, text: "choose_one", value: -1 }
        let t = [chooseOne]
        if (!snippets.isObjectEmpty(this.state.study.reports)) {
            let createNewOne = false
            let options = []
            Object.keys(this.state.study.reports).map(keys => {
                if (keys === "0" || this.state.canCreateReport === true) {
                    createNewOne = true
                } if (keys !== "0") {
                    options = [...options, { id: parseInt(keys),
                        text: `(${keys})  ${this.state.study.reports[keys].description_name}`,
                        value: keys }]
                }
            })
            t = [...t, ...options]
            if (createNewOne === true) {
                t = [...t, { id: 0, text: "create_report", value: 0 }]
            }
        }
        this.setState({ reportModals: t }, () => { })
    }

    initExpressions() {
        baseApi.fullFetch("expressions", "get", {version:2}).then((response) => {
            this.setState({ expressions: response.data?.expressions }, () => {})
        })
    }

    reloadEditor = () => {
        this.setState({editorKey: this.state.editorKey + 1})
    }

    handleChangeSelectedReportModal = (id)=> {
        if (id === "-1") {
            this.setState({ selectedReportModals: id })
        } else {
            this.setState({
                selectedReportModals: id.toString(),
            }, () => {
                this.props.handleChangeReport(this.state.selectedReportModals)
            })
        }
    }

    handleByKeyValue = (key, value) => {
        let someProperty = { ...this.state.NewStudyReport }
        someProperty[`${key}`] = value
        this.setState({ NewStudyReport: someProperty }, () => {
            this.handleReportLocalization()
        })
    }

    handleByKeyValueArray = (items) => {
        let someProperty = { ...this.state.NewStudyReport, ...items }
        this.setState({ NewStudyReport: someProperty }, () => {
            this.handleReportLocalization()
        })
    }

    handleReportLocalization() {
        console.log("New save")
        this.setState({uploaded: false})
        Storage.setNewStudyReport(this.state.study?.id, this.state.NewStudyReport?.id ?? 0, this.state.NewStudyReport)
    }

    handleCurrentWithServer = (server) => {
        return this.state.NewStudyReport?.findings === server.findings
    }

    serverRespond = (response) => {
        this.setState({uploaded: this.handleCurrentWithServer(response)}, () => {
            this.props.serverRespond(this.state.selectedReportModals, response)
        })
    }

    render() {
        return (
            <>
                <div className={"report_page"} style={{direction: this.state.direction}}>
                    <div className={'report'} >
                        <div className='report__section'>
                            <div className={"__right"} >
                                {/* eslint-disable-next-line react/jsx-pascal-case */}
                                <ReportCP_PatientInfo data={Object.assign({}, this.state.study, this.state.patientInfo)}  />
                            </div>

                            <div className={"__left"}>
                                {/* eslint-disable-next-line react/jsx-pascal-case */}
                                <ReportCP_ChooseReports study={this.state.study}
                                                        images={this.state.images}
                                                        report={this.state.NewStudyReport}
                                                        handleChangeSelectedImage={(id)=>this.handleByKeyValue("series_id", id)}
                                                        reportOptions={this.state.reportModals}
                                                        reportOptionSelected={this.state.selectedReportModals}
                                                        reportChanges={this.handleChangeSelectedReportModal}
                                />
                            </div>
                        </div>
                        {(this.state.selectedReportModals && this.state.selectedReportModals !== "-1") &&
                            <>
                                <hr />
                                <div className='Group2'>
                                    <div className='__right'>
                                        <LastModified report={this.state.data.study.reports[this.state.selectedReportModals]} />
                                    </div>
                                    <div className='__left'>
                                        {/* eslint-disable-next-line react/jsx-pascal-case */}
                                        <ReportCP_Buttons reportID={this.state.selectedReportModals}
                                                          NewStudyReport={this.state.NewStudyReport}
                                                          source={this.state.data.study.reports[this.state.selectedReportModals]}
                                                          serverRespond={this.serverRespond}
                                        />
                                    </div>
                                </div>

                                <hr />
                                <div className='Group3'>
                                    <div className='__right'>
                                        <div className={"__icon"}><i className={"fal fa-user-pen 2x"} /></div>
                                        <div className={"__title"}><T token={"owners"} /></div>
                                    </div>
                                    <div className={"__left"} >
                                        {/* eslint-disable-next-line react/jsx-pascal-case */}
                                        <ReportCP_ReportOwners NewStudyReport={this.state.NewStudyReport}
                                                               onChange={(who, value) => this.handleByKeyValue(who, value)}
                                                               changeValuesArray={this.handleByKeyValueArray}
                                       />
                                    </div>
                                </div>

                                <hr />
                                <div className={"Group4"}>
                                    {/* eslint-disable-next-line react/jsx-pascal-case */}
                                    <ReportCP_EditorViewer NewStudyReport={Object.assign({},
                                                                this.state.study,
                                                                this.state.patientInfo,
                                                                this.state.NewStudyReport,
                                                                this.state.canCreateAudio,
                                                                this.state.canAi
                                                            )}
                                                           editorKey={this.state.editorKey}
                                                           images={this.state.images}
                                                           expressions={this.state.expressions}
                                                           selectedReport={this.state.selectedReportModals}
                                                           reloadEditor={this.reloadEditor}
                                                           onChange={(who, value) => this.handleByKeyValue(who, value)}
                                                           changeValuesArray={this.handleByKeyValueArray}
                                    />
                                </div>
                            </>
                        }
                    </div >
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const direction = state.LangReducer.direction;
    return { language, direction };
};

export default connect(mapStateToProps)(withRouter(ReportCP));